import 'src/shared/js/utils/public-path';

// import styles
import 'src/shared/scss/index.scss';

import './components/';

import 'src/shared/js/globals/animation.js';

// only available in dev mode
if (process.env.NODE_ENV !== 'production') require('src/shared/js/dev/');

// require polyfills
require('loading-attribute-polyfill');
